import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import ClientSlider from "../Elements/ClientSlider"

// Background image
import BackgroundImage from "../../assets/img/images/company.jpg";

const values = [
  {
    title: "1. Trust",
    subtitle:
      "For us, trust is the foundation of a successful relationship. So we do everything it takes to build it. We value honesty and expect the same. We’re transparent, yet use discretion when needed. We feel safe enough to be around each other and around our partners and clients, to show vulnerability.",
  },
  {
    title: "2. Empathy",
    subtitle:
      "We’re sensitive to other people’s thoughts and feelings: their needs, opinions, inner drivers, challenges, business values, and goals. We listen, aim to understand, and act on them. We’re open to change, share perspectives, make decisions, and improve the way we work to make our relationships better.",
  },
  {
    title: "3. Collaboration",
    subtitle:
      "We foster team spirit, be it in an internal collaboration or a client project. We define rules and processes together and then respect them. We put on a partner hat—get engaged, provide support, ideate, and share knowledge and experience to achieve common goals.",
  },
  {
    title: "4. Commitment",
    subtitle:
      "We honor our obligations and keep our word by putting in the talent, skills, energy, and sincere effort. We combine hard work with a genuine enthusiasm for what we do. We hold ourselves accountable for getting things done so that we meet or exceed expectations.",
  },
  {
    title: "5. Innovation",
    subtitle:
      "We’re constant learners, soaking up the latest tech trends. This helps us forge an inspiring environment for creativity. This way, we bring relevant knowledge and skills to each project. We think outside the box. We’re not afraid to experiment, try new methods, and adapt them to specific needs and goals.",
  },
];

export default function CompanyValuesCarousel() {
  const settings = {
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  };

  return (
    <Section id="about">
    <>
<ClientSlider/>
      <Heading style={{color: "#7620ff", textAlign:"center",marginTop:"5rem",marginBottom:"1.3rem"}}>Our Company Values</Heading>
      <CarouselSection>
        <Slider {...settings}>
          {values.map((item, index) => (
            <CarouselSlide key={index}>
              <SlideContent>
                <TextBlock>
                  <h2>{item.title}</h2>
                  <p>{item.subtitle}</p>
                </TextBlock>
              </SlideContent>
            </CarouselSlide>
          ))}
        </Slider>
      </CarouselSection>
      </>
    </Section>
  );
}

// Styled Components

const Section = styled.div`
  width: 100%;
  background-color: #f9f9f9;
  text-align: center;
 
    font-family: 'Poppins', sans-serif; /* 👈 Add this line */

`;

const Heading = styled.h1`
  font-size: 2.1rem;
  color: #333;
  margin-bottom: 10px;
  text-align: start;
  padding-left: 40px;
 

  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0;
  }
`;

const CarouselSection = styled.div`
  position: relative;
  width: 100%;
  padding: 40px 0;
  background: url(${BackgroundImage}) center center / cover no-repeat;
  color: #fff;
  .slick-dots {
    bottom: 10px;
  }
`;

const CarouselSlide = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 40px;
  min-height: 400px;

  @media (max-width: 768px) {
    justify-content: center;
    padding: 0 20px;
  }
`;

const SlideContent = styled.div`
  max-width: 600px;
  width: 100%;
  text-align:right;
`;

const TextBlock = styled.div`
  background-color: rgba(0, 0, 0, 0.75);
  padding: 30px;
  border-radius: 12px;
  color: #fff;
  text-align: left;

  h2 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: #fff;
  }

  p {
    font-size: 1.125rem;
    color: #fff;
    line-height: 1.7;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;
